/**
 * stream.ts
 * Secured Communication
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/
import { ObjectId } from "bson";
import OT from "@opentok/client";

export enum AspectRatio {
  tv = 0.75,
  widescreen = 0.5625,
  anamorphic = 0.418,
  square = 1,
  phone = 1.85
}

export class SubscriberStream {

  private myID: string;
  stream: OT.Stream | null;
  subscriber: OT.Subscriber | null;
  nodeID: string;
  speaking: boolean;
  hiding: boolean;
  name: string;
  userID: string;
  deviceID: string;

  get streamId(): string {
    return this.myID;
  }

  get videoType(): "camera" | "screen" | "custom" {
    return this.stream?.videoType || "camera"; // (this.myID === "1" ? "screen" : "camera");
  }

  constructor(stream: OT.Stream | number) {
    if (typeof stream === "number") {
      this.myID = stream.toString();
      this.stream = null;
      this.name = this.myID + " and some text";
      this.userID = "";
      this.deviceID = "";
    } else {
      this.myID = stream.streamId;
      this.stream = stream;
      try {
        const data = JSON.parse(stream.name) as {name: string, userID: string, deviceID: string};
        this.name = data.name;
        this.userID = data.userID;
        this.deviceID = data.deviceID;
      } catch (err) {
        void err;
        this.name = stream.name;
        this.userID = "";
        this.deviceID = "";
      }

      if (!this.name) {
        // maybe it's a phone call
        try {
          const dataStr = stream.connection.data;
          const connData = JSON.parse(dataStr);
          if (connData.phoneNumber) {
            this.name = connData.phoneNumber;
          }
        } catch (err) {
          void err;
          // do nothing
        }
      }
    }
    this.subscriber = null;
    this.nodeID = new ObjectId().toString();
    this.speaking = false;
    this.hiding = true;
  }
}
